'use strict';

import constants from 'Constants.js';
import  _ from 'lodash';
import template from 'common-views/predefined-lists-modal.ejs';
import {View} from 'backbone';
import eventBus from 'EventBus.js';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import listService from 'ListService.js';

let availableLists=[{listId:"countries",name:'Countries'},{listId:"states",name:'US States'},{listId:"provinces",name:'Canada Provinces'}];

class PredefinedListsModalView extends View {
    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;

        return this;
    }

    closeModal() {
        listService.isUndoRedoEnabled = true;
        this.clearEventBus();
        $(constants.SELECT_FIELD_ID).remove();
    }

    selectItem(event) {
        this.model.set('predefinedList', event.target.value);
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));

            $('body').append(this.$el);
            listService.isUndoRedoEnabled = false;

            // Show modal popup window
            this.el = $(constants.SELECT_FIELD_ID).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 225,
                minHeight: 225,
                width: 400,
                minWidht: 280,
                modal: true,
                resizable: true,
                buttons: [
                    {
                        text: 'OK',
                        'class': 'btn-select-field',
                        'disabled': false,
                        click: () => {
                            this.closeModal();
                            resolve(this.model.get('predefinedList') || 'countries');
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    this.closeModal();
                },
                open: () => {
                  RestService.browseCustomList().then((customLists)=>{
                    this.model.set('predefinedList', '',{silent:true});
                      let listToRender=[...availableLists];
                      let customListsArray=customLists instanceof Array ? customLists : [customLists];
                          customListsArray.forEach((customList)=>{
                          listToRender.push({listId:customList["@CustomListId"],name:customList["@Name"]})
                      });
                      for (let list of listToRender) {
                        $('#predefinedList').append($('<option>', {
                          value: list.listId,
                          text: list.name
                        }))
                      }
                      $('#predefinedList').prop('size',listToRender.length);
                      $( constants.SELECT_FIELD_ID ).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                  }).catch((err=>{
                    console.log('Error retrieving custom list items ',err);
                    NotificationService.error('Error retrieving custom list items '+err.MESSAGE);
                  }));
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            // Attaching current scope to the change event of the dialog.
            $(constants.SELECT_FIELD_ID).on('change', $.proxy(this.selectItem, this));

            this.delegateEvents();
            return this;
        });
    }

    clearEventBus() {
        eventBus.off(constants.FIELD_SELECTED);
        eventBus.off(constants.FIELD_SELECTED_CLEAR);
    }
}

export default PredefinedListsModalView;
